import PaymentConnectedBrokers from "./ConnectedBrokers";

export default PaymentConnectedBrokers;
